module.exports = __webpack_public_path__ + "img/77356.283ab12e.svg";